export default __webpack_public_path__ + "static/media/ISVMs.850d5669.png";